import apiInstance from "@services/Shared/instanceAxios";

const deleteUser = (uuid: string) =>
  apiInstance({
    url: `/users/${uuid}`,
    method: "delete",
  });

export default deleteUser;
